import { Label } from "@omni/ui/components/Product/Label/label";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useCashbackContext } from "../../context/cashback.context";

export const ProductLabel = () => {
    const { t } = useGranite();

    const { cashbackAmount, cashbackUnit } = useCashbackContext();

    return (
        <Label
            position={"left"}
            type={"label"}
            className={cn("tw:uppercase")}
        >
            <Label.Entry>{t("promotionLabel.cashback")}</Label.Entry>
            <Label.Entry variant="secondary">
                {cashbackAmount}
                {cashbackUnit}
            </Label.Entry>
        </Label>
    );
};
